export default __webpack_public_path__ + "static/media/BannerImage.e3876b3d.gif";